import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardHeader } from '@/components/NCCard/NCCard';
import { IndicatorSpeciesExplainer } from '@/components/NCExplainers/FloraAndFaunaExplainer';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';
import { isNullish } from '@/utils/booleans';

import { GraphTile } from './components/GraphTile';
import { StatsTile } from './components/StatsTile';

const FACTS = {
  timeseries: 'r1_conservation_indicator_species_ts',
  baseline: 'r1_conservation_indicator_species_baseline_year_score',
  latest: 'r1_conservation_indicator_species_score',
  change: 'r1_conservation_indicator_species_change_percentage',
} as const;

export const IndicatorSpeciesCard = () => {
  const { t } = useTranslation();

  const graphFact = useFact<Record<string, number>>(FACTS.timeseries);
  const graphData = graphFact?.value;

  const baselineFact = useFact<number>(FACTS.baseline);
  const latestFact = useFact<number>(FACTS.latest);
  const changeFact = useFact<number>(FACTS.change);

  const hasStatsData =
    !isNullish(baselineFact?.value) || !isNullish(latestFact?.value) || !isNullish(changeFact?.value);

  if (!hasStatsData && isNullish(graphData)) {
    return null;
  }

  return (
    <NCCard explainer={<IndicatorSpeciesExplainer />}>
      <NCCardHeader title={t('shared.ncaDetail.indicatorSpecies.evolution.title')} className='lg:grid-cols-[1fr_1fr]' />
      <NCCard2SectionLayout className='[&>*]:py-8'>
        <GraphTile data={graphData ?? {}} />
        <StatsTile baselineFact={baselineFact} latestFact={latestFact} changeFact={changeFact} />
      </NCCard2SectionLayout>
    </NCCard>
  );
};
